module.exports = __webpack_public_path__ + "static/turtle-creek-house32-ce46c05cafdb913795a8219042691c7e.jpg";